import ProfileForm from './profile_form.vue'

export default {
    'profile-form': ProfileForm
}
